export default __webpack_public_path__ + "static/media/potato3.d62e62cf.png";